import dayjs from 'dayjs';
import utcPlugin from 'dayjs/plugin/utc';
dayjs.extend(utcPlugin);
export var formatDate = function (value, dateFormatter, timeFormatter) {
    if (dayjs(value).isValid()) {
        var datetime = void 0;
        if (isNaN(value)) {
            datetime = dayjs.utc(value);
        }
        else {
            datetime = dayjs.utc(+value * 1000);
        }
        var pattern = '';
        if (dateFormatter && dateFormatter.trim() !== 'hidden') {
            pattern += dateFormatter;
        }
        if (timeFormatter && timeFormatter.trim() !== 'hidden') {
            pattern += timeFormatter;
        }
        return datetime.format(pattern);
    }
    return value;
};
